const LABELS = {
  BUTTON: {
    DEFAULT_TEXT: 'Confirmar'
  }
};

export default LABELS;
